import React, { PureComponent } from 'react';
import Styles from '../constants/Styles';

class Loader extends PureComponent {
  
  constructor(props) {
    super(props);
  }

  render() {
    const { loading } = this.props;

    if (!loading && this.props.closeModal) this.props.closeModal(); //LMR TODO: changing state in render method! bad bad bad

    return (
      loading && (
        <div
          style={{
            display: 'flex',
            width: '100%',
            height: '100vh',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
          }}
        >
          <div>
            <img src={require('../assets/images/yinyang.gif').default} />
          </div>
        </div>
      )
    );
  }
}

export default Loader;
